import dynamic from 'next/dynamic';

export const getIcon = (nombre: string) =>
  dynamic(() => import(`@/assets/icons/${nombre || 'Call'}.svg`));
